import type React from 'react';
import { useState } from 'react';

import { EyeIcon, EyeShowIcon } from '../../../assets/icons';
import Input, { type Props } from '../Input/Input';

const NumericPassword: React.FC<Props> = (props) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const numsOnly = (value: string) => value.replace(/[^\d]/g, '');

  const Icon = isPasswordShown ? EyeShowIcon : EyeIcon;

  return (
    <Input
      {...props}
      showValidationTick={false}
      type={isPasswordShown ? 'text' : 'password'}
      parse={numsOnly}
      numericKeyboard
    >
      <Icon onClick={() => setIsPasswordShown(!isPasswordShown)} />
    </Input>
  );
};

export default NumericPassword;
